import axios from 'axios'
import config from '../config'
import auth from './auth'

function handleError(res) {
    if (res.response) {
        if (res.response.status == 401) {
            auth.logout();
        } else {
            throw res;
        }
    } else {
        throw res;
    }
}

export default {

    list(eventoId) {
        return axios.get(`${config.api_base_url}eventos/${eventoId}/campos-custom`)
            .then((res) => res.data.data)
            .catch(handleError);
    },

    create(eventoId, payload) {
        return axios.post(`${config.api_base_url}eventos/${eventoId}/campos-custom`, payload)
            .then((res) => res.data.data)
            .catch(handleError);
    },

    update(id, payload) {
        return axios.put(`${config.api_base_url}campos-custom/${id}`, payload)
            .then((res) => res.data.data)
            .catch(handleError);
    },

    remove(id) {
        return axios.delete(`${config.api_base_url}campos-custom/${id}`)
            .then((res) => res.data.data)
            .catch(handleError);
    },

    reorder(eventoId, ids) {
        return axios.post(`${config.api_base_url}eventos/${eventoId}/campos-custom/reorder`, { ids })
            .then((res) => res.data.data)
            .catch(handleError);
    },

}
